
(function() {
    if (window.__sktProductItemSwatchListLoaded) return
    window.__sktProductItemSwatchListLoaded = true

    const getIsPc = () => {
        const userAgentInfo = navigator.userAgent;
        const Agents = [
            "Android",
            "iPhone",
            "SymbianOS",
            "Windows Phone",
            "iPad",
            "iPod",
        ];
        let flag = true;
        for (let v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
            }
        }
        return flag;
    };

    function findEleByClass(ele, className) {
        if (ele === document.body || !ele) return null
        if (ele.className.indexOf?.(className) >= 0) return ele
        return findEleByClass(ele.parentElement, className)
    }

    function handleColorListMouseMove(ele) {
        if (ele.className.indexOf('product-item-meta__swatch-list-container--modal') >= 0) return

        let isMouseDown = false
        let lastPageX = null
        const moveEle = ele.querySelector('.product-item-meta__swatch-list')
        const parentEle = moveEle.parentElement
        const eleForArrow = parentEle.parentElement

        const scrollWidth = (moveEle.children?.length ?? 0) * 24
        let maxDiff = parentEle.offsetWidth - scrollWidth
        let translateX = 0
        let ancestor = findEleByClass(ele,'product-item-meta__swatch-list-container')
        let isPC = getIsPc()
        
        function handleMouseDown(e) {
            e.stopPropagation()
            isMouseDown = true
            lastPageX = isPC ? e.pageX : e.touches[0]?.pageX
        }
        
        function handleMouseUp(e) {
            e.stopPropagation()
            isMouseDown = false
            lastPageX = null
        }
        
        function handleMouseMove(e) {
            if (!isMouseDown || lastPageX === null) return
            e.stopPropagation()
            const curPageX = isPC ? e.pageX : e.touches[0]?.pageX
            const diff = lastPageX - curPageX
            translateX = Math.max(Math.min(0, translateX - diff), maxDiff)
            moveEle.style.transform = `translateX(${translateX}px)`
            lastPageX = curPageX
            updateStatusOfArrow(eleForArrow, translateX)
        }
        
        
        function initArrow (ele) {
            if (!ele) return
            if (![...ele.children]?.some((child) => child.className.indexOf('arrow') >= 0)) {
                return
            }

            const leftArrow = ele.querySelector('.arrow.left'), rightArrow = ele.querySelector('.arrow.right')
            leftArrow.className += ' disabled'
            leftArrow.className = leftArrow.className.replace('hidden', '')
            rightArrow.className = rightArrow.className.replace('hidden', '')
            setTimeout(function() {
                maxDiff = parentEle.offsetWidth - scrollWidth
            }, 10);

            leftArrow.removeEventListener('click', handleArrowClick('left', ele))
            leftArrow.addEventListener('click', handleArrowClick('left', ele))
            rightArrow.removeEventListener('click', handleArrowClick('right', ele))
            rightArrow.addEventListener('click', handleArrowClick('right', ele))
        }

        function recoverArrow(ele) {
            if (!ele) return
            if (![...ele.children]?.some((child) => child.className.indexOf('arrow') >= 0)) {
                return
            }

            const leftArrow = ele.querySelector('.arrow.left'), rightArrow = ele.querySelector('.arrow.right')
            if (leftArrow.className.indexOf('hidden') < 0) {
                leftArrow.className += ' hidden'
            }
            if (rightArrow.className.indexOf('hidden') < 0) {
                rightArrow.className += ' hidden'
            }
            leftArrow.removeEventListener('click', handleArrowClick('left', ele))
            rightArrow.removeEventListener('click', handleArrowClick('right', ele))
        }
        
        function updateStatusOfArrow(parentEle, translateX) {
            if (!parentEle) return
            const leftArrowDom = parentEle.querySelector('.arrow.left'), rightArrowDom = parentEle.querySelector('.arrow.right')
            if (translateX <= maxDiff) {
                if (leftArrowDom.className.indexOf('disabled') >= 0) {
                    leftArrowDom.className = leftArrowDom.className.replace('disabled', '')
                }
                if (rightArrowDom.className.indexOf('disabled') >= 0) return
                rightArrowDom.className += ' disabled'
            } else if (translateX === 0) {
                if (rightArrowDom.className.indexOf('disabled') >= 0) {
                    rightArrowDom.className = rightArrowDom.className.replace('disabled', '')
                }
                if (leftArrowDom.className.indexOf('disabled') >= 0) return
                leftArrowDom.className += ' disabled'
            } else {
                if (rightArrowDom.className.indexOf('disabled') >= 0) {
                    rightArrowDom.className = rightArrowDom.className.replace('disabled', '')
                }
                if (leftArrowDom.className.indexOf('disabled') >= 0) {
                    leftArrowDom.className = leftArrowDom.className.replace('disabled', '')
                }
            }
        }
        
        function handleArrowClick(direction, parentEle) {
            return function (e) {
                const moveEleWidth = moveEle.offsetWidth, isLeftBtn = direction === 'left'
                translateX = translateX + (!isLeftBtn ? -moveEleWidth : moveEleWidth)
                translateX = Math.max(Math.min(0, translateX), maxDiff)
                moveEle.style.transform = `translateX(${translateX}px)`
                updateStatusOfArrow(eleForArrow, translateX)
            }
        }
        
        function handleMouseScroll() {
            if (parentEle.scrollLeft > 0) {
                parentEle.scrollLeft = 0
            }
        }
        
        if (ele && maxDiff < 0) {
            initArrow(eleForArrow)
            moveEle.style.justifyContent = 'flex-start'

            // parentEle.removeEventListener('scroll', handleMouseScroll)
            // parentEle.addEventListener('scroll', handleMouseScroll)
            if (isPC) {
                ele.removeEventListener('mousedown', handleMouseDown)
                ele.removeEventListener('mousemove', handleMouseMove)
                ele.removeEventListener('mouseup', handleMouseUp)
                ancestor.removeEventListener('mouseleave', handleMouseUp)
                
                ele.addEventListener('mousedown', handleMouseDown)
                ele.addEventListener('mousemove', handleMouseMove)
                ele.addEventListener('mouseup', handleMouseUp)
                ancestor.addEventListener('mouseleave', handleMouseUp)
            } else {
                ele.removeEventListener('touchstart', handleMouseDown)
                ele.removeEventListener('touchmove', handleMouseMove)
                ele.removeEventListener('touchend', handleMouseUp)
                ancestor.removeEventListener('mouseleave', handleMouseUp)
                
                ele.addEventListener('touchstart', handleMouseDown)
                ele.addEventListener('touchmove', handleMouseMove)
                ele.addEventListener('touchend', handleMouseUp)
                ancestor.addEventListener('mouseleave', handleMouseUp)
            }
        } else {
            recoverArrow(eleForArrow)
        }
        
    }

    function addEventsToList(refresh) {
        const paginationDom = document.querySelector('.pagination__nav')
        if (paginationDom) {
            if (paginationDom === lastPaginationDom && !refresh) return false
            lastPaginationDom = paginationDom
            paginationDom.removeEventListener('click', handlePaginationClick)
            paginationDom.addEventListener('click', handlePaginationClick)
        }

        const productItems = document.querySelectorAll('.product-item-meta__swatch-list-container')
        if (productItems.length) {
            [...productItems].forEach(handleColorListMouseMove)
            return true
        }
        return false
    }

    let tryCount = 0, tryTimer = null, lastPaginationDom = null
    const maxTryCount = 10

    function tryToAddEvents() {
        if (tryTimer) {
            clearTimeout(tryTimer)
        }
        if (tryCount >= maxTryCount) return
        tryTimer = setTimeout(() => {
            const isAdded = addEventsToList()
            if (!isAdded) {
                tryToAddEvents()
                tryCount++
            } else {
                tryCount = 0
            }
        }, 500)
    }

    function handlePaginationClick() {
        tryToAddEvents()
    }

    function initProductItems(refresh) {
        addEventsToList(refresh)
    }

    function portalSwatchModal(modal, anchorContainer) {
        if (!modal._sktSwatchPortalHome) {
            modal._sktSwatchPortalHome = anchorContainer
        }

        modal._sktProductItem = anchorContainer.closest('product-item') || null

        if (modal.parentElement !== document.body) {
            document.body.appendChild(modal)
        }

        modal.classList.add('sk-swatch-modal--portaled')
    }

    function unportalSwatchModal(modal) {
        modal.classList.remove('sk-swatch-modal--portaled')

        const home = modal._sktSwatchPortalHome
        if (home && modal.parentElement === document.body) {
            home.appendChild(modal)
        }

        delete modal._sktSwatchPortalHome
        delete modal._sktProductItem
    }

    function hideSwatchModal(modal) {
        modal.classList.remove('is-open')
        modal.classList.remove('sk-swatch-modal--fixed')
        modal.classList.remove('sk-swatch-modal--above')
        modal.style.removeProperty('--sk-swatch-fixed-left')
        modal.style.removeProperty('--sk-swatch-fixed-top')
        modal.style.removeProperty('--sk-swatch-arrow-left')
        modal.setAttribute('hidden', '')
        unportalSwatchModal(modal)
    }

    function getViewportBottomInset() {
        const bundleCart = document.querySelector('.free-bundle-cart')
        if (!bundleCart) return 0

        const rect = bundleCart.getBoundingClientRect()
        if (rect.top >= window.innerHeight) return 0

        return Math.max(0, window.innerHeight - rect.top)
    }

    function getSwatchModalHeight(modal) {
        const height = modal.offsetHeight
        if (height > 0) return height
        return 264
    }

    function positionSwatchModal(button, modal) {
        const container = button.closest('.product-item-meta__swatch-list-container')
        if (!container) return

        const anchorRect = button.getBoundingClientRect()
        const containerRect = container.getBoundingClientRect()
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight
        const preferredWidth = Math.min(360, viewportWidth - 28)
        const left = Math.max(14, Math.min(containerRect.left, viewportWidth - preferredWidth - 14))
        const edgeGap = 14
        const anchorGap = 10
        const bottomInset = getViewportBottomInset()
        const modalHeight = getSwatchModalHeight(modal)
        const belowTop = anchorRect.bottom + anchorGap
        const aboveTop = anchorRect.top - modalHeight - anchorGap
        const belowOverflow = belowTop + modalHeight - (viewportHeight - edgeGap - bottomInset)

        let top = belowTop
        let placement = 'below'

        if (belowOverflow > 0 && aboveTop >= edgeGap) {
            top = aboveTop
            placement = 'above'
        }

        const arrowCenter = anchorRect.left + anchorRect.width / 2 - left
        const arrowLeft = Math.max(18, Math.min(arrowCenter - 6, preferredWidth - 30))

        modal.classList.add('sk-swatch-modal--fixed')
        modal.classList.toggle('sk-swatch-modal--above', placement === 'above')
        modal.style.setProperty('--sk-swatch-fixed-left', `${left}px`)
        modal.style.setProperty('--sk-swatch-fixed-top', `${top}px`)
        modal.style.setProperty('--sk-swatch-arrow-left', `${arrowLeft}px`)
    }

    function showSwatchModal(modal, button) {
        const container = button?.closest('.product-item-meta__swatch-list-container')

        if (container) {
            portalSwatchModal(modal, container)
        }

        modal.removeAttribute('hidden')
        modal.classList.add('is-open')

        if (button) {
            positionSwatchModal(button, modal)
            requestAnimationFrame(() => positionSwatchModal(button, modal))
        }
    }

    function closeAllSwatchModals(exceptModal) {
        document.querySelectorAll('[data-sk-swatch-modal]:not([hidden])').forEach((openModal) => {
            if (openModal !== exceptModal) {
                hideSwatchModal(openModal)
            }
        })
    }

    function openSwatchModal(button) {
        const container = button.closest('.product-item-meta__swatch-list-container')
        const modal = container?.querySelector('[data-sk-swatch-modal]')
        if (!modal) return

        const shouldOpen = modal.hasAttribute('hidden')

        closeAllSwatchModals(modal)

        if (shouldOpen) {
            const selectedInput = container.querySelector('.sk-product-card-swatch-list .color-swatch__radio:checked')
                || container.querySelector('.sk-product-card-swatch-list .color-swatch.is-selected .color-swatch__radio')

            showSwatchModal(modal, button)

            // Modal uses a separate radio name group; re-sync after portal so both sides match.
            if (selectedInput) {
                syncProductSwatchSelection(selectedInput)
            }
        } else {
            hideSwatchModal(modal)
        }
    }

    function closeSwatchModal(target) {
        const modal = target.closest('[data-sk-swatch-modal]')
        if (!modal) return

        hideSwatchModal(modal)
    }

    function getSwatchOwner(anchor) {
        const modal = anchor?.closest?.('[data-sk-swatch-modal]')
        return modal?._sktProductItem
            || anchor?.closest?.('product-item')
            || anchor?.closest?.('[data-bundle-product]')
            || null
    }

    function collectSwatchSyncRoots(anchor) {
        const roots = new Set()
        const modal = anchor?.closest?.('[data-sk-swatch-modal]')
        const owner = getSwatchOwner(anchor)

        if (owner) roots.add(owner)
        if (modal) roots.add(modal)

        if (owner) {
            const nestedModal = owner.querySelector('[data-sk-swatch-modal]')
            if (nestedModal) roots.add(nestedModal)

            document.querySelectorAll('.sk-swatch-modal--portaled').forEach((portaledModal) => {
                if (portaledModal._sktProductItem === owner) roots.add(portaledModal)
            })
        }

        return { owner, roots: Array.from(roots) }
    }

    function syncProductSwatchSelection(anchor, selectedValue, variantId) {
        const input = anchor?.matches?.('.color-swatch__radio') ? anchor : null
        const value = selectedValue ?? input?.value
        if (value == null || value === '') return

        const vId = variantId != null && variantId !== ''
            ? variantId
            : (input && input.getAttribute('data-variant-id')) || ''
        const { roots } = collectSwatchSyncRoots(anchor)
        if (!roots.length) return

        roots.forEach((root) => {
            root.querySelectorAll('.color-swatch__radio').forEach((picker) => {
                const isMatch = (vId && String(picker.dataset.variantId || '') === String(vId))
                    || picker.value === value
                picker.checked = isMatch
            })

            root.querySelectorAll('.color-swatch[data-swatch-value]').forEach((swatch) => {
                swatch.classList.toggle('is-selected', swatch.dataset.swatchValue === value)
            })
        })
    }

    window.SKTSyncProductSwatchSelection = syncProductSwatchSelection

    function formatProductCardMoney(cents) {
        const settings = window.themeVariables?.settings || {}
        const formatString = settings.currencyCodeEnabled
            ? (settings.moneyWithCurrencyFormat || settings.moneyFormat)
            : settings.moneyFormat
        const value = Number(cents) || 0

        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            return window.Shopify.formatMoney(value, formatString || settings.moneyFormat)
        }

        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
        const format = formatString || '${{amount}}'
        const match = format.match(placeholderRegex)
        const placeholder = match ? match[1] : 'amount'
        const precision = placeholder.indexOf('no_decimals') >= 0 ? 0 : 2
        const amount = (value / 100).toFixed(precision)
        return format.replace(placeholderRegex, amount)
    }

    function updateProductItemPrice(card, input) {
        if (!card || !input || !input.dataset.price) return

        const currentPrice = Number(input.dataset.price || 0)
        const comparePrice = Number(input.dataset.comparePrice || 0)
        const saleLabel = window.themeVariables?.strings?.productSalePrice || 'Sale price'
        const regularLabel = window.themeVariables?.strings?.productRegularPrice || 'Regular price'
        const formattedPrice = formatProductCardMoney(currentPrice)
        const isSale = comparePrice > currentPrice

        const priceEl = card.querySelector('[data-product-item-price]')
        const compareEl = card.querySelector('[data-product-item-compare]')

        if (priceEl) {
            priceEl.classList.toggle('price--highlight', isSale)
            priceEl.innerHTML = `<span class="visually-hidden">${saleLabel}</span>${formattedPrice}`
        }

        if (compareEl) {
            if (isSale) {
                compareEl.hidden = false
                compareEl.removeAttribute('hidden')
                compareEl.innerHTML = `<span class="visually-hidden">${regularLabel}</span>${formatProductCardMoney(comparePrice)}`
            } else {
                compareEl.hidden = true
                compareEl.setAttribute('hidden', '')
                compareEl.textContent = ''
            }
        }

        card.querySelectorAll('.product-item__cta-price').forEach((ctaPrice) => {
            ctaPrice.textContent = formattedPrice
            ctaPrice.classList.toggle('product-item__cta-price--sale', isSale)
        })
    }

    function syncSelectedSwatches(input) {
        syncProductSwatchSelection(input)
    }

    async function applyPortaledSwatchChange(input, productItem) {
        if (productItem.hasAttribute('data-bundle-product')) {
            syncPortaledBundleCardVariant(productItem, input)
            return
        }

        if (input.hasAttribute('data-variant-featured-media')) {
            const mediaId = input.getAttribute('data-variant-featured-media')
            const newImage = productItem.querySelector(
                `.product-item__primary-image[data-media-id="${CSS.escape(mediaId)}"]`,
            )

            if (newImage && window.SKProductItemDeferredImages?.ensure) {
                await window.SKProductItemDeferredImages.ensure(newImage)
            }
        }

        if (typeof productItem._onColorSwatchChanged === 'function') {
            await productItem._onColorSwatchChanged({ target: input }, input)
        }

        updateProductItemPrice(productItem, input)
    }

    function syncPortaledBundleCardVariant(card, input) {
        const variantId = input.getAttribute('data-variant-id')
        const selectedValue = input.value

        // Keep visible + modal radios/classes in sync across separate name groups + portal.
        syncProductSwatchSelection(input, selectedValue, variantId)

        const image = card.querySelector('[data-bundle-card-image]')
        const available = input.dataset.available === 'true'

        card.dataset.selectedVariantId = input.dataset.variantId || ''
        card.dataset.selectedVariantTitle = input.dataset.variantTitle || ''
        card.dataset.selectedSku = input.dataset.sku || ''
        card.dataset.selectedPrice = input.dataset.price || ''
        card.dataset.selectedImage = input.dataset.image || card.dataset.selectedImage
        card.dataset.selectedAvailable = String(available)
        card.classList.toggle('product-item--sold-out', !available)

        if (image && input.dataset.image) {
            image.removeAttribute('srcset')
            image.src = input.dataset.image
        }

        card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
            try {
                const url = new URL(link.href, window.location.origin)
                url.searchParams.set('variant', input.dataset.variantId)
                link.href = url.toString()
            } catch (error) {
                // Ignore malformed product links.
            }
        })

        // Colors beyond the first 5 only exist in the modal — notify the bundle section
        // so price/CTA update even when there is no matching in-card radio.
        card.dispatchEvent(new CustomEvent('skt:bundle-variant-sync', {
            bubbles: true,
            detail: { input },
        }))
    }

    function handleSwatchChange(input) {
        syncSelectedSwatches(input)

        const modal = input.closest('[data-sk-swatch-modal]')
        if (modal?.classList.contains('sk-swatch-modal--portaled') && modal._sktProductItem) {
            void applyPortaledSwatchChange(input, modal._sktProductItem)
            return
        }

        const productItem = getSwatchOwner(input)
        if (productItem?.hasAttribute?.('data-bundle-product')) return
        if (productItem) {
            updateProductItemPrice(productItem, input)
        }
    }

    document.addEventListener('click', (event) => {
        const openButton = event.target.closest('[data-sk-swatch-open]')
        if (openButton) {
            event.preventDefault()
            event.stopPropagation()
            openSwatchModal(openButton)
            return
        }

        const closeButton = event.target.closest('[data-sk-swatch-close]')
        if (closeButton) {
            event.preventDefault()
            event.stopPropagation()
            closeSwatchModal(closeButton)
            return
        }

        if (!event.target.closest('[data-sk-swatch-modal]')) {
            closeAllSwatchModals()
        }
    }, true)

    document.addEventListener('change', (event) => {
        const input = event.target.closest('.color-swatch__radio')
        if (!input) return

        handleSwatchChange(input)
    })

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return

        closeAllSwatchModals()
    })

    window.addEventListener('DOMContentLoaded',() => {
        initProductItems()
    })

    window.addEventListener('resize', () => {
        closeAllSwatchModals()
        initProductItems(true)
    })

    window.addEventListener('scroll', () => closeAllSwatchModals(), true)

})()
